var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100"}},[_c('path',{attrs:{"d":"M50,0C3.6,0-17.3,54.9,18.9,82.3V100l16.9-9.4c31.7,8.9,63.7-13.4,63.7-44.4C99.5,20.7,77.3,0,50,0z M55.2,62.1L42.4,48.8 L17.8,62.4l27-28.7L57.6,47l24.6-13.6L55.2,62.1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }